module.exports = __webpack_public_path__ + "71a3cb59a0569d4d190adae8deb59617.fbx";